/** @jsxImportSource @emotion/react */
import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button";
import { styErrorView } from "./styles";

const ErrorView = ({ text }: { text: string }) => {
  const navigate = useNavigate();

  return (
    <div css={styErrorView}>
      <div>
        <p>{text}</p>
        <Button onClick={() => navigate("/")}>Back to home</Button>
      </div>
    </div>
  );
};

export default ErrorView;
